'use strict'
var ImagePicker = require('./Modal')

module.exports = ImagePicker;
